






















import Vue, { PropType } from "vue";
import _icons from "../../services/icons";
import MenuWingComp from "../aufstellung/MenuWingComp.vue";
import { Encounter } from "../../../../models/Encounter";

export default Vue.extend({
	name: "BlankoHeaderComp",
	components: { MenuWingComp },
	props: {
		boss: Object as PropType<Encounter>,
		role: Number,
	},
	methods: {
		icon: function(): string {
			if (this.boss) return _icons.encIcon(this.boss.abbr);
			else return "";
		},
		copyBlanko: async function(info: Encounter): Promise<void> {
			this.$emit("copyBlanko", [info.id, this.boss.id]);
		},
	},
});
